import { useEffect, useState } from "react";
import { Icon, EmptyState, SkeletonCard } from "../../components/Common.jsx";
import { getChangelog } from "../../lib/api";
import { fmtDate } from "../../lib/dates.js";

const CATEGORY_META = {
  feature:      { label: "New",         badge: "badge-primary", icon: "sparkles" },
  improvement:  { label: "Improved",    badge: "badge-info",    icon: "trending-up" },
  fix:          { label: "Fixed",       badge: "badge-success", icon: "wrench" },
  announcement: { label: "Announcement", badge: "badge-warning", icon: "megaphone" },
};

export default function LatestUpdates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getChangelog()
      .then((d) => { if (!cancelled) setItems(d?.items || []); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section>
      <div className="page-head">
        <div>
          <h1 className="page-title">Latest Updates</h1>
          <p className="page-sub">What's new and improved in the platform</p>
        </div>
      </div>

      {loading ? (
        <div style={{ display: "grid", gap: 14 }}>
          <SkeletonCard />
          <SkeletonCard />
        </div>
      ) : items.length === 0 ? (
        <EmptyState title="No updates yet" desc="Product updates will appear here." icon="sparkles" />
      ) : (
        <div style={{ position: "relative", paddingLeft: 4 }}>
          {items.map((it) => {
            const meta = CATEGORY_META[it.category] || CATEGORY_META.feature;
            return (
              <div key={it.id} className="card" style={{ marginBottom: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span className={`badge ${meta.badge}`}>
                      <Icon name={meta.icon} size={12} /> {meta.label}
                    </span>
                    {it.version && (
                      <span style={{ fontSize: 12, fontWeight: 700, color: "var(--text-muted)" }}>{it.version}</span>
                    )}
                  </div>
                  <span style={{ fontSize: 12, color: "var(--text-dim)" }}>{fmtDate(it.publishedAt)}</span>
                </div>
                <h3 style={{ fontSize: 16, fontWeight: 700, margin: "12px 0 6px" }}>{it.title}</h3>
                <p style={{ fontSize: 13.5, color: "var(--text-muted)", lineHeight: 1.65, whiteSpace: "pre-wrap", margin: 0 }}>
                  {it.body}
                </p>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
